import React from 'react';
import { Box, Typography, Link, Stack, useTheme, useMediaQuery } from '@mui/material';
import addressIcon from '../assets/yelloloc.png'; // replace with your uploaded icon
import contactIcon from '../assets/yelloinpho.png'; // your combined email + phone icon
import combinedLogo from '../assets/pdt-logo-white 1.png'; 

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      id="footer-section"
      component="footer"
      sx={{
        backgroundColor: '#0d111c',
        color: '#CBD5E1',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: isMobile ? '30px 20px' : '40px 30px',
        fontFamily: 'Outfit',
      }}
    >
      {/* Left Logo & About */}
      <Box sx={{ flex: '1 1 25%', mb: isMobile ? 3 : 0 }}>
        <Stack direction="column" spacing={2}>
          <Box>
            <img
              src={combinedLogo}
              alt="Property Deals Talk Logo"
              style={{
                width: isMobile ? 140 : 190,
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.4,
              color: '#CBD5E1',
              marginTop: '5px',
            }}
          >
            A great platform to buy, sell and rent your properties without any agent or commissions.
          </Typography>
        </Stack>
      </Box>
      {/* Middle Links */}
      {/* Middle Links */}
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 50%',
          flexDirection: isMobile ? 'row' : 'row', // ✅ stay side by side on mobile
          flexWrap: 'wrap',
          justifyContent: 'space-between', // ✅ force space between on both
          columnGap: isMobile ? 0 : '60px',
          rowGap: isMobile ? 0 : '24px',
          mb: isMobile ? 3 : 0,
        }}
      >
        {/* Information Links */}
        <Box sx={{ flex: '1 1 auto', minWidth: 140, ml: isMobile ? 0 : 14 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
            Information Links
          </Typography>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['Terms & Conditions', 'Privacy Policy', 'Contact'].map((text, i) => (
              <li key={i} style={{ marginBottom: 6 }}>
                <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </Box>
        {/* Useful Links */}
        <Box
          sx={{
            flex: '1 1 auto',
            minWidth: 140,
            ml: isMobile ? 0 : 'auto',
            mr: isMobile ? 0 : 11,
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
            Useful Links
          </Typography>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['About Us', 'Services', 'Login'].map((text, i) => (
              <li key={i} style={{ marginBottom: 6 }}>
                <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </Box>
      </Box>
      {/* Contact Details */}
      <Box
        sx={{
          flex: '1 1 25%',
          textAlign: isMobile ? 'center' : 'left',
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
          Contact Details
        </Typography>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ marginBottom: 10 }}>
            <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
              <Box component="img" src={addressIcon} alt="address" sx={{ width: 16, height: 16, mr: 1 }} />
              <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                Kukatpally, Hyderabad, Telangana - 72
              </Typography>
            </Stack>
          </li>
          <li style={{ marginBottom: 10 }}>
            <Link href="#" underline="none" sx={{ color: '#FF9900', fontWeight: 500, fontSize: 17 }}>
              View on Google map
            </Link>
          </li>
          <li>
            <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
              <Box
                component="img"
                src={contactIcon}
                alt="contact"
                sx={{ width: 18, height: 57, mr: 1.5 }}
              />
              <Box>
                <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link 
                    href="mailto:propertydealstalk@gmail.com" 
                    underline="none" 
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    propertydealstalk@gmail.com
                  </Link>
                </Typography>
                <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link 
                    href="tel:+919346799389" 
                    underline="none" 
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    +91 93467 99389
                  </Link>
                </Typography>
                 <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link 
                    href="tel:+917780251777" 
                    underline="none" 
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    +91 77802 51777
                  </Link>
                </Typography>
              </Box>
            </Stack>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default Footer;